module.exports = __webpack_public_path__ + "img/orders-icon.6466f24.svg";